module.exports = function() {
    this.init = function()
    {
        const params = this.getSearchParameters();

        this.cinemaSaleshouses(params);
        this.televisionChannelSearch(params);
        this.pressReports(params);
    }

    this.pressReports = function(params) {
        if (!params.prpos) {
            return;
        }

        const pos = parseInt(params.prpos);
        const ifr = document.querySelectorAll("iframe[id='press_application-search']");
        ifr[0].onload = function() {
            const divContainer = ifr[0].contentDocument.querySelectorAll("div[id='target_reports_custom_available']");
            setTimeout(function(){
                divContainer[0].querySelectorAll("a")[pos - 1].click();
            }, 4000);
        };
    }

    this.cinemaSaleshouses = function(params) {
        if (!params.csrecord) {
            return;
        }

        switch (params.cstab) {
            case 'overview':
            case 'packages':
            case 'contacts':
            case 'promotions':
            case 'production':
                document.querySelectorAll("a[href='/cinema/saleshouse/" + params.csrecord + "/panel']")[0].click();
                setTimeout('document.querySelectorAll("a[href=\'/online/site-data/' + params.csrecord + '/' + params.cstab + '\']")[0].click()', 2000);
        }
    }

    this.televisionChannelSearch = function(params) {
        if (!params.tcspos) {
            return;
        }

        const pos = parseInt(params.tcspos);
        const ifr = document.querySelectorAll("iframe[id='television_channel-search']");
        ifr[0].onload = function() {
            const frameset = ifr[0].contentDocument.querySelectorAll("frameset")[0];
            const properFrame = frameset.children[0].children[0];

            setTimeout(function(){
                properFrame.contentDocument.querySelectorAll("a")[pos - 1].click();
            }, 1000);
        };
    }

    this.getSearchParameters = function()
    {
        const prmstr = window.location.search.substr(1);

        return prmstr != null && prmstr != "" ? this.transformToAssocArray(prmstr) : {};
    }

    this.transformToAssocArray = function(prmstr)
    {
        const params = {};
        const prmarr = prmstr.split("&");
        for (let i = 0; i < prmarr.length; i++) {
            const tmparr = prmarr[i].split("=");
            params[tmparr[0]] = tmparr[1];
        }

        return params;
    }
};
